import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import Handlebars from 'handlebars';
import handlebarsHelpers from 'handlebarsHelpers';
import Global from 'models/Global';
import MeMenuView from 'views/MeMenuView';
import RenderedView from 'views/RenderedView';
import navMenu from 'hbars!templates/navMenu';
import meMenu from 'hbars!templates/meMenu';
import unpublishedTemplate from 'hbars!templates/unpublished_view';
import businessTemplate from 'hbars!web-common/editor-templates/templates/business/navigation';
import sleekTemplate from 'hbars!web-common/editor-templates/templates/sleek/navigation';
import classicTemplate from 'hbars!web-common/editor-templates/templates/classic/navigation';
import urbanTemplate from 'hbars!web-common/editor-templates/templates/urban/navigation';
import tradeTemplate from 'hbars!web-common/editor-templates/templates/trade/navigation';
import insiderTemplate from 'hbars!web-common/editor-templates/templates/insider/navigation';
import globalTemplate from 'hbars!web-common/editor-templates/templates/global/navigation';

Handlebars.registerPartial('navMenu', navMenu);
Handlebars.registerPartial('meMenu', meMenu);

var NavigationView = RenderedView.extend({

    templates: {
        business: businessTemplate,
        sleek: sleekTemplate,
        classic: classicTemplate,
        urban: urbanTemplate,
        trade: tradeTemplate,
        insider: insiderTemplate,
        global: globalTemplate
    },

    initialize: function(options) {
        options = options || {};
        this.event = options.event;
        this.me = options.me;
        this.disableInteractions = options.disableInteractions;
        const siteConf = this.model.toJSON();
        const visibleTabs = _.where(siteConf.tabs, {visible: true});
        const isCommunityEnabled = _.some(visibleTabs, {type: 'community'});

        this.meMenuView = new MeMenuView({
            model: this.me,
            isCommunityEnabled: isCommunityEnabled
        });

        this.findTemplate();

        this.listenTo(this.model.get('tabs'), 'change:selected', this.render);
        this.listenTo(this.event, 'change:status', this.renderUnpublishedBar);
    },

    remove: function() {
        this.meMenuView.remove();
        return Backbone.View.prototype.remove.call(this);
    },

    findTemplate: function() {
        this.template = this.templates[this.model.get('template')];
    },

    renderUnpublishedBar: function() {
        var isPublish = (this.event.get('status') == 'published');
        var html = unpublishedTemplate({...this.event.toJSON()});
        this.$el.prepend(html);
        $('body').toggleClass('unpublished-event', !isPublish);
    },

    render: function() {
        var event = this.event.toJSON();
        var siteConf = this.model.toJSON();
        var visibleTabs = _.where(siteConf.tabs, {visible: true});
        var hasLogo = siteConf.navigationBarLogoVisible && siteConf.navigationBarLogo;

        siteConf.showMoreTab = visibleTabs && (visibleTabs.length > this.model.getMaxTabs(event, hasLogo));

        RenderedView.prototype.render.call(this, this.template, _.extend(siteConf, {
            event: event,
            me: this.me.toJSON(),
            indexOfMore: hasLogo ? 5 : 6,
            visibleTabs: visibleTabs
        }));
        return this;
    },

    postRender: function() {
        var templateClass = this.model.get('template') + '-template';
        if (!this.$el.hasClass(templateClass)) {
            var wrapperDiv = '<div class="' + this.model.get('template') + '-template">' + this.$el.html() + '</div>';
            this.$el.html(wrapperDiv);
        }
        this.meMenuView.setElement(this.$('.header-top-me')).render();
        this.renderUnpublishedBar();
        return this;
    }
});

export default NavigationView;


